import React, { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-scroll';

const TableOfContents = ({ tableOfContents, sections }) => {
  const [activeSection, setActiveSection] = useState('');
  
  // Use sections prop if provided, otherwise use tableOfContents
  const items = sections || tableOfContents;

  const getActiveSection = useCallback(() => {
    const sectionElements = items.map(item => document.getElementById(item.id));
    const scrollPosition = window.scrollY;

    for (let i = sectionElements.length - 1; i >= 0; i--) {
      const section = sectionElements[i];
      if (section && section.offsetTop <= scrollPosition + 100) {
        return items[i].id;
      }
    }

    return items[0]?.id || '';
  }, [items]);

  useEffect(() => {
    const handleScroll = () => {
      const currentSection = getActiveSection();
      if (currentSection !== activeSection) {
        setActiveSection(currentSection);
      }
    };

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setActiveSection(entry.target.id);
          }
        });
      },
      { rootMargin: '-20% 0% -80% 0%', threshold: 0.1 }
    );

    items.forEach((item) => {
      const element = document.getElementById(item.id);
      if (element) observer.observe(element);
    });

    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Call once to set initial active section

    return () => {
      observer.disconnect();
      window.removeEventListener('scroll', handleScroll);
    };
  }, [items, activeSection, getActiveSection]);

  return (
    <nav className="max-h-[calc(100vh-8rem)] overflow-auto">
      <ul className="space-y-1">
        {items.map((item) => (
          <li key={item.id}>
            <Link
              to={item.id}
              spy={true}
              smooth={true}
              duration={500}
              offset={-100}
              className={`block text-sm py-2 px-3 rounded-lg transition-colors cursor-pointer ${
                activeSection === item.id
                  ? 'bg-[#f2f9ff] text-[#06c] font-medium border-l-2 border-[#06c] pl-4'
                  : 'text-[#424245] hover:bg-[#f5f5f7] hover:text-[#1d1d1f]'
              }`}
            >
              {item.title}
            </Link>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default TableOfContents;